// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1G0By","emails":"CreateEditClinics_emails__O5reM","emailTagLabel":"CreateEditClinics_emailTagLabel__3qpzj"};